var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuaranteed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_678_1202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9273 0.70752C22.5737 4.04688 6.87213 10.9001 0.70752 10.9001V35.1058C0.70752 46.4869 23.5689 58.9341 24.9132 59.2925C26.2574 58.9341 49.1188 45.6144 49.1188 36.3792V10.9001C42.3929 10.9001 27.2809 4.0516 24.9273 0.70752Z",
    stroke: "#003053",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9132 52.9392C25.9744 52.6562 44.0202 42.3316 44.0202 35.1057",
    stroke: "#DDC77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9131 7.07495C23.0548 9.68795 10.669 14.7206 5.80615 14.7206V33.8276",
    stroke: "#DDC77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5367 31.4503L20.7861 39.6997L37.2848 20.4512",
    stroke: "#003053",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_678_1202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.8263,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuaranteed);
export default __webpack_public_path__ + "static/media/Guaranteed.ff97e8a8c9f4344088bef6c85d9d4b31.svg";
export { ForwardRef as ReactComponent };